module.exports = __webpack_public_path__ + "img/carshina21_04.ea751cd7.jpg";